import React, { useEffect, useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, Grid, IconButton, MenuItem, Modal, Paper, Select, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';

const initialValue = {
    "membershipName": "",
    "membershipPrice": '',
    "duration": '',
    "condition": "",
    "rewardPointsOnPurchase": '',
    "discountOnService": '',
    "discountOnProducts": '',
    "discountOnPackage": '',
    "minBilledAmount": '',
    "rewardPointsBoost": '',
    "minRewardPointsEarn": ''
}


const AddMembership = () => {
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { createMembership } = useMain();

    const handleSubmit = async () => {
       
        const { membershipName, membershipPrice, duration, condition, rewardPointsOnPurchase, discountOnService, discountOnProducts, discountOnPackage, minBilledAmount, rewardPointsBoost, minRewardPointsEarn } = formData;
        if (membershipName.trim() === '') return setErrorMessage('Service Name is Required');
        if (condition === '') return setErrorMessage('Condition is Required');
        if (duration === '') return setErrorMessage('Duration is Required');
        if (rewardPointsBoost === '') return setErrorMessage('Rewards field is Required');
        if (membershipPrice === '') return setErrorMessage('Membership Price is Required');
        if (rewardPointsOnPurchase === '') return setErrorMessage('Reward Points is Required');
        if (discountOnPackage === '') return setErrorMessage('Discount Field is Required');
        if (discountOnProducts === '') return setErrorMessage('Discount Field is Required');
        if (discountOnService === '') return setErrorMessage('Discount Field is Required');
        if (minBilledAmount === '') return setErrorMessage('Billed Amt is Required');
        if (minRewardPointsEarn === '') return setErrorMessage('Rewards Field is Required');
        setShowLoader(true);

        const res = await createMembership(JSON.stringify(formData));

        if (res?.status === 200) {
            setSuccessMessage('Service Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Create Membership" description="this is add Membership">
            <DashboardCard title="Create Membership">
                <Snackbar
                    open={errorMessage === '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Membership type Name'}
                                name={'membershipName'}
                                value={formData?.membershipName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Reward points of Purchase'}
                                name={'rewardPointsOnPurchase'}
                                value={formData?.rewardPointsOnPurchase}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Discount on Packages'}
                                name={'discountOnPackage'}
                                value={formData?.discountOnPackage}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Membership Price'}
                                name={'membershipPrice'}
                                value={formData?.membershipPrice}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Discount on  Service'}
                                name={'discountOnService'}
                                value={formData?.discountOnService}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Reward Points Boost'}
                                name={'rewardPointsBoost'}
                                value={formData?.rewardPointsBoost}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Duration'}
                                name={'duration'}
                                value={formData?.duration}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Discount on Products'}
                                name={'discountOnProducts'}
                                value={formData?.discountOnProducts}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Min Reward Points earn'}
                                name={'minRewardPointsEarn'}
                                value={formData?.minRewardPointsEarn}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Condition'}
                                name={'condition'}
                                value={formData?.condition}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Min Bill Amount'}
                                name={'minBilledAmount'}
                                value={formData?.minBilledAmount}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>


                {showLoader && <ShowLoader value={showLoader} />}
                {successMessage != '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddMembership